// export { LgReleaseNotesService } from "./lg-release-notes.service";
// export { LgReleaseNotesDialogFactory } from "./lg-release-notes-dialog.component";

export * from "./lg-release-notes.service";
export * from "./lg-release-notes-dialog.component";
